import { css } from 'styled-components';

export const brandSpecificNavBorderStyle = css<{ isWhiteBGFlagOn?: boolean }>`
  ${({ ...props }) => {
    if (props.isWhiteBGFlagOn) {
      return css`
        box-shadow: 0px -1px 1px 0px #0000001a;
        border-block-start: none;
      `;
    } else {
      return css``;
    }
  }}
`;
